module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Purple-Monsters-Joyful-Scene-1280.a6adda96.jpg";